// this file is generated by generate-icons.js. Do not edit!
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SVGAttachment = props => /*#__PURE__*/_jsxs("svg", Object.assign({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  children: [/*#__PURE__*/_jsxs("g", {
    clipPath: "url(#attachment__clip0_14386_16283)",
    children: [/*#__PURE__*/_jsx("path", {
      fillOpacity: 0.01,
      d: "M0 0h24v24H0z"
    }), /*#__PURE__*/_jsx("mask", {
      id: "attachment__b",
      style: {
        maskType: 'alpha'
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 24,
      height: 24,
      children: /*#__PURE__*/_jsx("g", {
        clipPath: "url(#attachment__clip1_14386_16283)",
        children: /*#__PURE__*/_jsxs("g", {
          clipPath: "url(#attachment__clip2_14386_16283)",
          children: [/*#__PURE__*/_jsx("mask", {
            id: "attachment__a",
            style: {
              maskType: 'alpha'
            },
            maskUnits: "userSpaceOnUse",
            x: 1,
            y: 2,
            width: 22,
            height: 19,
            children: /*#__PURE__*/_jsx("path", {
              d: "M7.551 20.793c-1.491 0-2.991-.566-4.122-1.706-1.132-1.14-1.706-2.571-1.706-4.123 0-1.551.608-3.026 1.706-4.123L9.29 4.98c.335-.335.875-.335 1.209 0 .334.334.334.874 0 1.208L4.637 12.05c-.78.78-1.208 1.817-1.208 2.914 0 1.097.428 2.135 1.208 2.914 1.603 1.603 4.217 1.603 5.829 0l9.385-9.385c.96-.96.96-2.52 0-3.48s-2.52-.96-3.48 0l-9.385 9.386c-.309.317-.309.822 0 1.13.3.3.831.3 1.131 0l5.863-5.862c.334-.334.874-.334 1.209 0 .334.334.334.874 0 1.209l-5.863 5.862c-.952.952-2.606.952-3.557 0-.978-.977-.978-2.58 0-3.557l9.385-9.385c1.629-1.629 4.277-1.629 5.906 0 1.629 1.628 1.629 4.277 0 5.905l-9.386 9.386c-1.14 1.14-2.631 1.706-4.123 1.706z"
            })
          }), /*#__PURE__*/_jsx("g", {
            mask: "url(#attachment__a)",
            children: /*#__PURE__*/_jsx("path", {
              d: "M-1.714-1.715h27.429v27.429H-1.714z"
            })
          })]
        })
      })
    }), /*#__PURE__*/_jsx("g", {
      mask: "url(#attachment__b)",
      children: /*#__PURE__*/_jsx("path", {
        d: "M0 0h24v24H0V0z"
      })
    })]
  }), /*#__PURE__*/_jsxs("defs", {
    children: [/*#__PURE__*/_jsx("clipPath", {
      id: "attachment__clip0_14386_16283",
      children: /*#__PURE__*/_jsx("path", {
        d: "M0 0h24v24H0z"
      })
    }), /*#__PURE__*/_jsx("clipPath", {
      id: "attachment__clip1_14386_16283",
      children: /*#__PURE__*/_jsx("path", {
        d: "M0 0h24v24H0z"
      })
    }), /*#__PURE__*/_jsx("clipPath", {
      id: "attachment__clip2_14386_16283",
      children: /*#__PURE__*/_jsx("path", {
        transform: "translate(-1.714 -1.715)",
        d: "M0 0h27.429v27.429H0z"
      })
    })]
  })]
}));
SVGAttachment.displayName = 'SVGAttachment';
export default SVGAttachment;